import React from 'react';
import Textfield from '@atlaskit/textfield';
export var EditNumber = function EditNumber(_ref) {
  var id = _ref.id,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(Textfield, {
    id: id,
    value: value,
    isInvalid: isInvalid,
    isRequired: isRequired,
    onChange: onChange,
    width: "small",
    label: label,
    "aria-label": label,
    title: label,
    placeholder: ""
  });
};